export enum ERoutes {
  Home = "/",
  Login = "/login",
  Transactions = "/transactions",
  Requests = "/requests",
}
